import { h } from "omi";

import { IconProps } from "@/wc/components";

export function LetterAIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 14" fill="none">
      <path
        d="M3 8.14582H9M1 12.1458L5.27171 2.74807C5.50308 2.23905 5.61876 1.98454 5.77907 1.90558C5.91837 1.83697 6.08163 1.83697 6.22093 1.90558C6.38124 1.98454 6.49692 2.23905 6.72829 2.74807L11 12.1458"
        stroke="#101828"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
